import React, {useEffect, useRef, useState} from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

type Props = {
    profileName: string,
    onUndo: () => void,
    onConfirm: () => Promise<void>,
};

export const RemoveRoleNotification = ({profileName, onUndo, onConfirm}: Props) => {
    const [seconds, setSeconds] = useState(5);
    const timer = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        timer.current = setTimeout(() => {
            if (seconds > 0) {
                setSeconds(prevSeconds => prevSeconds - 1);
            } else if (seconds === 0) {
                onConfirm();
            }
        }, 1000);

        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, [seconds, onConfirm]);

    return seconds > 0 ? (
        <Group>
            <div>Role <b>{profileName}</b> will be deleted in {seconds} {pluralize('second[s]', seconds)}.</div>
            <FlatButton onClick={() => {
                setSeconds(-1);
                if (timer.current) {
                    clearTimeout(timer.current);
                }
                onUndo();
            }}>
                Undo
            </FlatButton>
        </Group>
    ) : (
        <div>Role <b>{profileName}</b> is being deleted.</div>
    );
};
